module.exports = __webpack_public_path__ + "img/floor_OG1.f3d64a4b.svg";